import { adminHttpClient } from '../../../commons/adminHttpClient'

export type NotifyEmployeesFormValues = {
  notificationDate: string
}

const notifyEmployees = (payload: NotifyEmployeesFormValues): Promise<any> => {
  console.log(payload)
  return adminHttpClient.post('/AdminDashboard/Renewal/NotifyEmployees', payload)
}

export default notifyEmployees
